import { render } from "./AIDeepLoading.vue?vue&type=template&id=80bcd65a&scoped=true"
const script = {}

import "./AIDeepLoading.vue?vue&type=style&index=0&id=80bcd65a&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80bcd65a"]])

export default __exports__